/**
 * Nulls values a logarithmic y-axis can't plot (y <= 0), so they render as a
 * gap instead of throwing Highcharts error #10. See ADR 0002 for why gapping
 * (not clamping or symlog) and which series need it.
 *
 * Handles the three point shapes the main chart uses:
 *   - `[x, y]` pairs
 *   - `[x, low, high]` band triples — nulled as a whole (a band needs both edges)
 *   - `{ x, y, rawValue }` objects — `rawValue` kept so the tooltip can still
 *     show the real underlying metric
 *
 * No-op unless `axisScale === 'logarithmic'`.
 */
const dropPoint = (point) => {
  if (Array.isArray(point)) {
    // [x, low, high] — an arearange band point.
    if (point.length >= 3) {
      const [x, low, high] = point;
      const unplottable = low == null || high == null || low <= 0 || high <= 0;
      return unplottable ? [x, null, null] : point;
    }
    const [x, y] = point;
    return y != null && y <= 0 ? [x, null] : point;
  }
  if (point && typeof point === 'object') {
    return point.y != null && point.y <= 0 ? { ...point, y: null } : point;
  }
  return point;
};

export const logSafe = (data, axisScale) => (
  axisScale === 'logarithmic' && Array.isArray(data) ? data.map(dropPoint) : data
);
